import React from 'react';
import { observer } from 'mobx-react-lite';

import { gameStore } from '../../../store';

const RoundResultSection = observer(() => {
  const { pastRoundsData } = gameStore;

  return (
    <div className='monti-nums-structure'>
      <div className='monti-game-nums-holder'>
        <div className='monti-game-nums-decor' />
        <div className='monti-game-nums'>
          <div className='monti-game-num-wrapper'>
            {pastRoundsData.map((pastRound) => (
              <div className='monti-game-num' key={pastRound.roundId}>
                {pastRound.roundData}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
});

export default RoundResultSection;
